/**
 * Tooltip
 */

var _ = require('underscore');

/**
 * Create a new tooltip instance.
 *
 * Options:
 * - box: Element for boundary check
 * - tooltip: Tooltip element (optional). Will be created on demand.
 * - className: Class for styling (only for auto-generated tooltips)
 */
var Tooltip = function(options) {
	_.bindAll(this, "updatePosition", "set", "hide", "boxHasChanged");

	this.box = null;
	this.tooltip = null;
	this.className = "";
	this.boxTransform = function(box) { return box; };
	_.extendOwn(this, options);

	if ( !this.tooltip ) {
		this.tooltip = $('<div>').addClass(this.className).css({
			"position": "absolute",
			"z-index": 9999,
		});
		this.tooltip.appendTo('body');
	}

	/* Mapping of {x1, x2, y1, y2} of this.box */
	this.box_rect = null;
	/* Bool: Is the mouse inside box_rect? */
	this.inside_box = false;
	/* Last tooltip text */
	this.last_tooltip = null;
	/* Timeout for calling updatePosition */
	this.update_timer = null;
	/* Timeout for boxCheck */
	this.box_timer = null;

	/* Tracking of mouse position. */
	this.pointerX = -1000;
	this.pointerY = -1000;
	this.previousPointerX = -1000;
	this.previousPointerY = -1000;

	$(document).mousemove(function(e) {
		this.pointerX = e.pageX;
		this.pointerY = e.pageY;
	}.bind(this));
};


/**
 * Set or override the tooltip content. Also shows and updates the position.
 *
 * @param text {String} Tooltip content. Can be any HTML.
 */
Tooltip.prototype.set = function(text) {
	console.log(`[Tooltip] set("${text}")`, );
	this.last_tooltip = text;
	this.tooltip.html(text);
	this.updatePosition();
};

/**
 * Hide the tooltip and reset display timers.
 */
Tooltip.prototype.hide = function() {
	console.log("[Tooltip] hide()");
	if ( this.update_timer ) {
		window.clearInterval(this.update_timer);
		this.update_timer = null;
	}
	this.last_tooltip = null;
	this.tooltip.hide();
};


/**
 * Notifies the tooltip if the size of the box has changed. Needed for a correct box check.
 */
Tooltip.prototype.boxHasChanged = function() {
	this.box_rect = null;
};


/**
 * Internal: Check if the pointer is currently inside the bounding box.
 * Sets the attributes inside_box.
 */
Tooltip.prototype.boxCheck = function() {
	if ( !this.box.length || !this.box.offset ) {
		this.inside_box = false;
		return;
	}

	// Calculate the box rectangle to prevent strange tooltip positions
	if ( ! this.box_rect ) {
		var box = this.box;
		var offset = box.offset();
		this.box_rect = this.boxTransform({
			x1: offset.left,
			y1: offset.top,
			x2: offset.left + box.outerWidth(),
			y2: offset.top + box.outerHeight(),
		});
	}

	/* Check if the mouse pointer is inside the box

	  x1,y1
		+--------+
		| Px,Py  |
		|   +    |
		+--------+
				x2,y2
	*/
	var box = this.box_rect;
	/* Wir haben einen "Puffer" von 10 Pixel außerhalb der Box da Browser manchmal zu langsam sind
	   die Maus-Position schnell genug zu aktualisieren und wir dann beim Boxcheck einen alten
	   Wert haben, der noch außerhalb der Box ist. */
	this.inside_box = (
			this.pointerX >= box.x1 - 10
		 && this.pointerY >= box.y1 - 10
		 && this.pointerX <= box.x2 + 10
		 && this.pointerY <= box.y2 + 10
	);
};


/**
 * Internal: Update the position of the tooltip and show/hide it depending on position.
 */
Tooltip.prototype.updatePosition = function() {
	if ( this.last_tooltip === null ) {
		return;
	}

	this.boxCheck();
	if ( this.inside_box ) {
		if ( this.previousPointerY !== this.pointerY || this.previousPointerX !== this.pointerX ) {
			//console.log(`[Tooltip] position -> (${this.pointerX + 15}, ${this.pointerY + 15})`);
			this.tooltip.show().css({
				top: this.pointerY + 15,
				left: this.pointerX + 15,
			});

			this.previousPointerY = this.pointerY;
			this.previousPointerX = this.pointerX;
		}
	} else {
		this.last_tooltip = null; // @todo configurable?
		this.tooltip.hide();
	}

	this.update_timer = setTimeout(this.updatePosition, 1000 / 30);
};


module.exports = Tooltip;


/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/Tooltip.js
 **/